"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedPaymentCurrencyResponseWithCount = exports.mockedPaymentCurrencyResponse = exports.mockedPaymentCurrencyUpdateRequest = exports.mockedPaymentCurrencyCreateRequest = void 0;
const common_interfaces_1 = require("../../common-interfaces");
const date_util_1 = require("../../utils/date.util");
const country_1 = require("../country");
const payment_provider_1 = require("../payment-provider");
exports.mockedPaymentCurrencyCreateRequest = {
  countryIds: [1],
  currency: common_interfaces_1.Currency.dollar
};
exports.mockedPaymentCurrencyUpdateRequest = {
  countryIds: [175],
  currency: common_interfaces_1.Currency.dollar
};
exports.mockedPaymentCurrencyResponse = {
  id: 1,
  countries: [country_1.mockedCountryResponse],
  fee: 0,
  feeFixed: 0,
  notes: '',
  paymentProvider: payment_provider_1.mockedPaypalPaymentProvider,
  template: '',
  currency: common_interfaces_1.Currency.dollar,
  isDeleted: false,
  isActive: true,
  createdAt: date_util_1.takeDaysFromNow(),
  updatedAt: null
};
exports.mockedPaymentCurrencyResponseWithCount = {
  items: [exports.mockedPaymentCurrencyResponse],
  count: 1
};